import React, { useEffect, useState } from "react";
import tampuuriWindowObject from "../../tampuuriWindowObject.js";

const CardBottom = (props) => {
  const {
    card,
    href,
    handleFavoriteClick,
    favouriteClassname,
    isRoomOrApartment,
    svgObjects,
    localStorageFavouriteObject,
  } = props;
  const { translate, constructApartmentName } = tampuuriWindowObject();

  return (
    <div className="card-buttons">
      <button
        data-favourite-object={JSON.stringify(localStorageFavouriteObject)}
        data-add-announcer-message={translate("Lisätty suosikiksi")}
        data-remove-announcer-message={translate("Poistettu suosikeista")}
        onClick={handleFavoriteClick}
        className={"favourite " + favouriteClassname}
      >
        <div
          className="hoas-svg-icon"
          dangerouslySetInnerHTML={{
            __html: svgObjects?.heart,
          }}
        />
        {favouriteClassname === "active"
          ? translate("Poista suosikeista")
          : translate("Lisää suosikiksi")}
        <span className="sr-only">
          {constructApartmentName(localStorageFavouriteObject?.address)}
        </span>
      </button>
      <a href={href}>
        {isRoomOrApartment(card)
          ? translate("Siirry asunnon sivulle")
          : translate("Siirry kohteen sivulle")}
        <span className="sr-only">
          {constructApartmentName(localStorageFavouriteObject?.address)}
        </span>
      </a>
    </div>
  );
};

export default CardBottom;
